module.exports = __webpack_public_path__ + "img/dash-circle-fill.f364d23f.svg";